const getUserLang = () => {
  // do this on demand for testing.
  return window.navigator.language.toLowerCase();
};

export default getUserLang;
